/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import { v1 as uuidv1 } from 'uuid';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function SupplierField({
  style,
  disabled,
  placeholder,

  config,

  onInputSelect,
}) {
  const conf = config || { pay_group_lookup_code: '' };
  const { pay_group_lookup_code } = conf;

  const [suppliers, setSuppliers] = useState([]);
  const [loading, isLoading] = useState(false);
  const [key, setKey] = useState(uuidv1());
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadSuppliers = async () => {
    try {
      isLoading(true);

      const suppls = await mySEAOIL.datawarehouse.view({
        viewName: 'seaoil_payee',
        schema: 'erp',
        filters: (() => {
          const output = [];

          output.push({
            key: 'enabled_flag',
            operation: Buffer.from('=').toString('base64'),
            value: 'Y',
          });

          if (pay_group_lookup_code) {
            output.push({
              key: 'pay_group_lookup_code',
              operation: Buffer.from('=').toString('base64'),
              value: pay_group_lookup_code,
            });
          }

          return output;
        })(),
        orderBy: [
          {
            field: 'vendor_name',
            value: 'ASC',
          },
        ],
        limit: 15000,
      }).send();

      setSuppliers(suppls.records);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load payees after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load payees. Retrying after 2 seconds...' });
        setTimeout(loadSuppliers, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    setKey(uuidv1());
    if (pay_group_lookup_code) {
      loadSuppliers();
    }
  }, [pay_group_lookup_code]);

  useEffect(() => {
    if (!pay_group_lookup_code) {
      loadSuppliers();
    }
  }, []);

  useEffect(() => {
    if (!Array.isArray(suppliers)) {
      return;
    }
    setOptions(suppliers.map(({
      vendor_name,
    }) => ({
      value: vendor_name,
      label: vendor_name,
    })));
  }, [suppliers]);

  return (
    <AsyncAutoComplete
      placeholder={placeholder}
      key={key}
      style={style}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(vendor_name) => {
        if (suppliers) {
          onInputSelect(suppliers.find((supplier) => supplier.vendor_name === vendor_name));
        }
      }}
    />
  );
}

export default SupplierField;
